import React, { useCallback } from 'react';
import lowerCase from 'lodash/lowerCase';

import { useTranslation } from '@lyearn/i18n';
import FormLayout from '@/components/Form/components/FormLayout';
import AddWorkspaceSettings, {
  WorkspaceSubjectType,
} from '@/modules/corporate/modules/workspaceSettings/components/AddWorkspacesSettings';

type WorkspaceSettingsProps = {
  selectedValues?: string[];
  onChange: (values?: string[]) => void;
  className?: string;
  contentName: string;
  type?: WorkspaceSubjectType;
  disabled?: boolean;
  title?: React.ReactNode;
  hideDescription?: boolean;
  hideTitle?: boolean;
};

function WorkspaceSettings(props: WorkspaceSettingsProps) {
  const { t } = useTranslation('Workspace');
  const {
    selectedValues,
    onChange,
    className,
    contentName,
    type,
    disabled,
    title,
    hideDescription,
    hideTitle = false,
  } = props;

  const onRemove = useCallback(
    (id: string) => {
      const newValues = selectedValues?.filter((item) => item !== id);
      onChange(newValues);
    },
    [onChange, selectedValues],
  );

  return (
    <FormLayout className={className}>
      {title || (!hideTitle && <FormLayout.Title>{t('Common:Form.Workspaces')}</FormLayout.Title>)}
      {hideDescription ? null : (
        <FormLayout.Description>
          {t('Workspace:Description', {
            contentName: lowerCase(contentName),
          })}
        </FormLayout.Description>
      )}
      <AddWorkspaceSettings
        disabled={disabled}
        selectedValues={selectedValues}
        type={type}
        onChange={onChange}
        onRemove={onRemove}
      />
    </FormLayout>
  );
}

export default WorkspaceSettings;
